<div class="home-hero">
  <div class="home-hero-content">
    @if (currentUser()?.AcceptTC) {
      <div class="wtw-container">
        <div class="wtw-layout-col-span--12 hero-content">
          <div class="logo-wrapper">
            <img ngOptimizedImage src="assets/images/logo.svg" width="80" height="80" alt="Colab Logo" class="home-logo" />
            <h1 class="wtw-typography-display--xl wtw-typography-font-weight--semibold">CoLab</h1>
          </div>
          <h2 class="wtw-typography-display--md wtw-typography-font-weight--semibold">
            Your virtual sandbox for <span>digital innovation</span>
          </h2>
          <p class="wtw-typography-text--sm wtw-typography-font-weight--medium">
            This is your chance to be at the forefront of our digital developments, <br />helping us shape the solutions of
            tomorrow.
          </p>
          <button class="explore wtw-typography-text--sm wtw-typography-font-weight--medium" (click)="scrollToAllModules()">
            Explore Modules
          </button>
        </div>
      </div>

      <div class="secondary-intro wtw-container">
        <div class="wtw-layout-grid">
          <div class="wtw-layout-col-span--8 flex-column">
            <h2 class="wtw-typography-display--xs wtw-typography-font-weight--bold">What can you do in CoLab?</h2>
            <p class="wtw-typography-text--sm wtw-typography-font-weight--medium">
              As a valued client, you have exclusive access to explore our latest features, insights and visualizations before they
              are broadly available.
              <br /><br />
              CoLab is your virtual sandbox for digital innovation, where you can interact with cutting-edge capabilities designed
              to enhance your experience and where your feedback helps shape the solutions.
              <br /><br />
              Keep in mind that some features are in development and may not be perfect yet.
            </p>
          </div>
          <div class="wtw-layout-col-span--4">
            @if (currentUser()?.Modules?.length) {
              <button class="module-box" (click)="goToFirstModule()">
                <div class="top">
                  <div class="wtw-typography-text--sm wtw-typography-font-weight--medium">Try our newest module</div>
                  <h3 class="wtw-typography-display--xs wtw-typography-font-weight--bold">
                    {{ currentUser()!.Modules[0].ModuleName }}
                  </h3>
                </div>
                <div class="icon-container">
                  <span class="wtw-functional-icons wtw-icon-size--3xl" aria-hidden="true">chevron_right</span>
                </div>
              </button>
            } @else {
              <button class="module-box empty">
                <div class="top">
                  <div class="wtw-typography-text--sm wtw-typography-font-weight--medium">New modules are coming soon</div>
                  <h3 class="wtw-typography-display--xs wtw-typography-font-weight--bold">Stay tuned!</h3>
                </div>
                <div class="icon-container">
                  <!-- <span class="wtw-functional-icons wtw-icon-size--3xl" aria-hidden="true">chevron_right</span> -->
                </div>
              </button>
            }
          </div>
        </div>
      </div>
    } @else {
      <app-terms></app-terms>
    }
  </div>
  <div class="bg-image-wrapper">
    <img src="assets/images/bg.png" class="hero-background" alt="background" />
  </div>
</div>
@if (currentUser()?.AcceptTC && currentUser()?.Modules?.length) {
  <div class="wtw-container home-module" id="all-modules">
    <div class="header-row">
      <h2 class="wtw-typography-display--md wtw-typography-font-weight--semibold">All Modules</h2>
    </div>

    <div class="module-grid" [ngClass]="{ 'grid-2': currentUser()?.Modules?.length === 2 }">
      <app-module-card
        *ngFor="let module of currentUser()?.Modules"
        [title]="module.ModuleName"
        [text]="module.Description"
        [url]="getModuleUrl(module)"
        [code]="module.ModuleCode"
        [isMaintenance]="module.IsMaintenance"
      />
      @if ((currentUser()?.Modules?.length ?? 0) < 3) {
        <app-module-card
          [isOverflow]="true"
          [title]="'Coming soon!'"
          [text]="'We are launching more modules soon.<br/><br/>Stay tuned!'"
          url=""
          code=""
          [isMaintenance]="false"
        />
      }
    </div>
  </div>
}
